import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsCompany(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_COMPANY && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsCompany(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsCompany(submission) {
  if (isContactsCompany(submission)) {
    return _formatContactsCompany(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-company-preview.js.map